import { createIcon } from '../icons/utils';

/**
 * Scheduled transmission glyph: a purple rounded tile with a white "S". Its
 * colors are baked into the SVG (every shape carries an explicit `fill`/`stroke`),
 * so it renders the same regardless of the priority `className` / `innerClassName`
 * the lane passes — a scheduled transmission is not priority-coloured. It still
 * accepts `innerClassName` (satisfying the shared icon prop contract) but
 * deliberately ignores it; it's destructured out of `...rest` so it isn't spread
 * onto the <svg> DOM node.
 */
export const ScheduledPatientTimelineIcon = createIcon(
  ({ ref, className, innerClassName, width, height, ...rest }) => (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {/* Scale the tile down and re-center it within the viewBox so it sits
          with padding inside the surrounding badge. */}
      <g transform="translate(1.95 1.95) scale(0.85)">
        <rect x="0.5" y="0.5" width="25" height="25" rx="4.5" fill="#A855F7" />
        <rect
          x="0.5"
          y="0.5"
          width="25"
          height="25"
          rx="4.5"
          stroke="#A855F7"
        />
        <path
          d="M13.1379 19.216C12.2259 19.216 11.4159 19.054 10.7079 18.73C9.99988 18.406 9.44788 17.944 9.05188 17.344C8.65588 16.744 8.45188 16.03 8.43988 15.202H10.7259C10.7259 15.622 10.8219 16 11.0139 16.336C11.2179 16.66 11.4939 16.918 11.8419 17.11C12.2019 17.302 12.6339 17.398 13.1379 17.398C13.5699 17.398 13.9419 17.332 14.2539 17.2C14.5779 17.056 14.8239 16.858 14.9919 16.606C15.1719 16.342 15.2619 16.036 15.2619 15.688C15.2619 15.292 15.1659 14.968 14.9739 14.716C14.7939 14.452 14.5419 14.23 14.2179 14.05C13.8939 13.87 13.5219 13.714 13.1019 13.582C12.6819 13.438 12.2379 13.288 11.7699 13.132C10.7739 12.796 10.0239 12.37 9.51988 11.854C9.01588 11.326 8.76388 10.624 8.76388 9.748C8.76388 9.016 8.93788 8.386 9.28588 7.858C9.63388 7.33 10.1199 6.922 10.7439 6.634C11.3799 6.334 12.1119 6.184 12.9399 6.184C13.7799 6.184 14.5119 6.334 15.1359 6.634C15.7719 6.934 16.2699 7.354 16.6299 7.894C17.0019 8.422 17.1939 9.058 17.2059 9.802H14.9019C14.8899 9.49 14.8059 9.202 14.6499 8.938C14.4939 8.662 14.2659 8.44 13.9659 8.272C13.6779 8.092 13.3239 8.002 12.9039 8.002C12.5439 7.99 12.2199 8.05 11.9319 8.182C11.6559 8.302 11.4339 8.482 11.2659 8.722C11.1099 8.95 11.0319 9.238 11.0319 9.586C11.0319 9.922 11.1039 10.204 11.2479 10.432C11.4039 10.648 11.6259 10.834 11.9139 10.99C12.2019 11.134 12.5379 11.272 12.9219 11.404C13.3059 11.536 13.7259 11.68 14.1819 11.836C14.8059 12.04 15.3699 12.292 15.8739 12.592C16.3899 12.88 16.7979 13.258 17.0979 13.726C17.3979 14.194 17.5479 14.8 17.5479 15.544C17.5479 16.192 17.3799 16.798 17.0439 17.362C16.7079 17.914 16.2159 18.364 15.5679 18.712C14.9199 19.048 14.1099 19.216 13.1379 19.216Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  {
    displayName: 'ScheduledPatientTimelineIcon',
    defaultSize: 26,
    classNameBase: '',
  },
);
